import React from 'react';
import LookerReport from './LookerReport';

const UserAuthAnalytics = () => {
  return <LookerReport source="user_activities" title="User Auth Analytics" />;
};

export default UserAuthAnalytics;